import { KeyboardEvent, useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";

type OrderNumberRouteDialogProps = {
  open: boolean;
  title?: string;
  onClose: () => void;
  onSubmit: (orderNumber: string) => void;
};

export default function OrderNumberRouteDialog({ open, title, onClose, onSubmit }: OrderNumberRouteDialogProps) {
  const [orderNumber, setOrderNumber] = useState("");

  useEffect(() => {
    if (open) {
      setOrderNumber("");
    }
  }, [open]);

  const handleSubmit = () => {
    const trimmedOrderNumber = orderNumber.trim();

    if (trimmedOrderNumber) {
      onSubmit(trimmedOrderNumber);
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Order number"
          value={orderNumber}
          onChange={(event) => setOrderNumber(event.target.value)}
          onKeyDown={handleKeyDown}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={!orderNumber.trim()}>
          Go
        </Button>
      </DialogActions>
    </Dialog>
  );
}
